/**
 * Assure rate_id et rate sur une commande (aligné sur les ventes : sale.rate.name).
 * Défaut : rate_id = 1 (HTG) si absent pour éviter les erreurs d’affichage.
 */
export function normalizeOrderForRate(order) {
  if (!order || typeof order !== 'object') return order
  const raw = order.rate_id
  const rid = raw != null && raw !== '' && !Number.isNaN(Number(raw)) ? Number(raw) : 1
  order.rate_id = rid
  if (!order.rate || typeof order.rate !== 'object') {
    order.rate = { id: rid, name: rid === 2 ? 'USD' : 'HTG' }
  } else {
    if (order.rate.name == null || order.rate.name === '') {
      order.rate.name = rid === 2 ? 'USD' : 'HTG'
    }
    if (order.rate.id == null) order.rate.id = rid
  }
  return order
}
